// הגדרת סגנון אחיד לכל רכיבי react-select
export const selectStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: 'bg-background',
    borderColor: 'rgba(131,130,120,0.37)',
    padding: '0.1rem',
    borderRadius: '0', // cancel border rounded
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: '#424242',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#374151',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#fff',
  }),
  singleValue: (base) => ({
    ...base,
    color: '#fff',
  }),
  input: (base) => ({ ...base, color: '#fff' }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#DC2626' : '#424242',
    color: isFocused ? '#fff' : '#d1d5db',
  }),
}

export const borderlessSelectStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: 'transparent', // רקע שקוף
    border: 'none', // מסיר את המסגרת
    boxShadow: 'none', // מסיר צללים
    padding: '0',
    display: 'flex',
    alignItems: 'center', // מוודא יישור טוב של החץ עם הטקסט
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: '#424242',
  }),
  singleValue: (base) => ({
    ...base,
    color: '#fff',
    paddingRight: '4px', // מקרב את החץ לטקסט
  }),
  input: (base) => ({ ...base, color: '#fff' }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#DC2626' : '#424242',
    color: isFocused ? '#fff' : '#d1d5db',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '0', // מסיר ריווח פנימי מיותר
  }),
  indicatorSeparator: () => ({
    display: 'none', // ❌ מסיר את הקו המפריד
  }),
}

export const currentYear = new Date().getFullYear()
export const yearsOptions = [
  { value: currentYear.toString(), label: currentYear.toString() }, // מוסיפים את השנה הנוכחית קודם
  ...Array.from({ length: currentYear - 1961 }, (_, i) => ({
    value: (currentYear - 1 - i).toString(),
    label: (currentYear - 1 - i).toString(),
  })),
]

export const genresList = [
  { value: 'Action', label: 'Action / אקשן' },
  { value: 'Adventure', label: 'Adventure / הרפתקאות' },
  { value: 'Comedy', label: 'Comedy / קומדיה' },
  { value: 'Drama', label: 'Drama / דרמה' },
  { value: 'Fantasy', label: 'Fantasy / פנטזיה' },
  { value: 'Horror', label: 'Horror / אימה' },
  { value: 'Mystery', label: 'Mystery / מסתורין' },
  { value: 'Romance', label: 'Romance / רומנטיקה' },
  { value: 'Suspense', label: 'Suspense / מתח' },
  { value: 'Sci-Fi', label: 'Sci-Fi / מדע בדיוני' },
  { value: 'Supernatural', label: 'Supernatural / על טבעי' },
  { value: 'Sports', label: 'Sports / ספורט' },
  { value: 'Boys Love', label: 'Boys Love / אהבת בנים' },
  { value: 'Girls Love', label: 'Girls Love / אהבת בנות' },
  { value: 'Award Winning', label: 'Award Winning / זוכה פרס' },
  { value: 'Gourmet', label: 'Gourmet / בישול' },
  { value: 'Horror', label: 'Horror / אימה' },
  { value: 'Slice of Life', label: 'Slice of Life / חלק מהחיים' },
  { value: 'Avant Garde', label: 'Avant Garde / אנימה ניסיונית' },
]

export const themesList = [
  { value: 'Adult Cast', label: 'Adult Cast / קהל בוגר' },
  { value: 'Anthropomorphic', label: 'Anthropomorphic / האנשה' },
  { value: 'CGDCT', label: 'CGDCT / בנות חמודות' },
  { value: 'Childcare', label: 'Childcare / טיפול בילדים' },
  { value: 'Combat Sports', label: 'Combat Sports / קרבות ספורט' },
  { value: 'Crossdressing', label: 'Crossdressing / הלבשה' },
  { value: 'Delinquents', label: 'Delinquents / עבריינות' },
  { value: 'Detective', label: 'Detective / בלשות' },
  { value: 'Educational', label: 'Educational / חינוכי' },
  { value: 'Gag Humor', label: 'Gag Humor / קומדיה הומוריסטית' },
  { value: 'Gore', label: 'Gore / גור' },
  { value: 'Harem', label: 'Harem / הרמון (נשים)' },
  { value: 'High Stakes Game', label: 'High Stakes Game / משחקי מזל' },
  { value: 'Historical', label: 'Historical / היסטורי' },
  { value: 'Idols (Female)', label: 'Idols (Female) / מפורסמת' },
  { value: 'Idols (Male)', label: 'Idols (Male) / מפורסם' },
  { value: 'Isekai', label: 'Isekai / עולם אחר' },
  { value: 'Iyashikei', label: 'Iyashikei / מצב ריפוי' },
  { value: 'Love Polygon', label: 'Love Polygon / אהבה יותר מאישה אחת' },
  { value: 'Love Status Quo', label: 'Love Status Quo / משולש אהבה' },
  { value: 'Magical Sex Shift', label: 'Magical Sex Shift / שינוי מגדרי קסום' },
  { value: 'Mahou Shoujo', label: 'Mahou Shoujo / ילדות קסומות' },
  { value: 'Martial Arts', label: 'Martial Arts / אומנויות לחימה' },
  { value: 'Mecha', label: 'Mecha / רובוטים' },
  { value: 'Medical', label: 'Medical / רפואה' },
  { value: 'Military', label: 'Military / צבאי' },
  { value: 'Music', label: 'Music / מוזיקה' },
  { value: 'Mythology', label: 'Mythology / מיתולוגיה' },
  { value: 'Organized Crime', label: 'Organized Crime / פשע מאורגן' },
  { value: 'Otaku Culture', label: 'Otaku Culture / תרבות האוטקו' },
  { value: 'Parody', label: 'Parody / פרודיה' },
  { value: 'Performing Arts', label: 'Performing Arts / אמנות במה' },
  { value: 'Pets', label: 'Pets / חיות' },
  { value: 'Psychological', label: 'Psychological / פסיכולוגיה' },
  { value: 'Racing', label: 'Racing / מרוצים' },
  { value: 'Reincarnation', label: 'Reincarnation / חזר לחיים' },
  { value: 'Reverse Harem', label: 'Reverse Harem / הרמון (גברים)' },
  { value: 'Samurai', label: 'Samurai / סמוראי' },
  { value: 'School', label: 'School / בית ספר' },
  { value: 'Showbiz', label: 'Showbiz / תעשיית הבידור' },
  { value: 'Space', label: 'Space / חלל' },
  { value: 'Strategy Game', label: 'Strategy Game / משחק אסטרטגיה' },
  { value: 'Super Power', label: 'Super Power / כוחות מיוחדים' },
  { value: 'Survival', label: 'Survival / הישרדות' },
  { value: 'Team Sports', label: 'Team Sports / ספורט קבוצתי' },
  { value: 'Time Travel', label: 'Time Travel / מסע בזמן' },
  { value: 'Urban Fantasy', label: 'Urban Fantasy / פנטזיה אורבנית' },
  { value: 'Vampire', label: 'Vampire / ערפדים' },
  { value: 'Video Game', label: 'Video Game / משחק מחשב' },
  { value: 'Villainess', label: 'Villainess / נבלות' },
  { value: 'Visual Arts', label: 'Visual Arts / אומנות חזותית' },
  { value: 'Workplace', label: 'Workplace / מקום עבודה' },
]

export const statusOptions = [
  { value: 'Finished Airing', label: 'הסתיים' },
  { value: 'Currently Airing', label: 'בשידור' },
  { value: 'Not yet aired', label: 'עדיין לא שודר' },
]

export const demographicsOptions = [
  { value: 'Josei', label: 'Josei / נשים' },
  { value: 'Kodomo', label: 'Kodomo / ילדים' },
  { value: 'Seinen', label: 'Seinen / מתבגרים' },
  { value: 'Shoujo', label: 'Shoujo / נערה' },
  { value: 'Shounen', label: 'Shounen / נער' },
]

export const sortOptions = [
  { value: '', label: 'הכל' },
  { value: 'favorites', label: 'הכי אהובים' },
  { value: 'popularity', label: 'הכי פופולרים' },
  { value: 'score', label: 'הכי מדורגים' },
]

export const scoreOptions = [
  { value: '10', label: '(10) יצירת מופת' },
  { value: '9', label: '(9) מצוין' },
  { value: '8', label: '(8) טוב מאוד' },
  { value: '7', label: '(7) טוב' },
  { value: '6', label: '(6) בסדר' },
  { value: '5', label: '(5) ממוצע' },
  { value: '4', label: '(4) גרוע' },
  { value: '3', label: '(3) גרוע מאוד' },
  { value: '2', label: '(2) נורא' },
  { value: '1', label: '(1) מחריד' },
]

export const DEFAULT_FILTER = {
  title: '',
  genres: [],
  themes: [],
  year: '',
  status: '',
  demographics: [],
  top100: false,
  score: '',
  sort: '',
  excludeMatureContent: true,
}
